/**
 * @file 端内调用h5 兼容报错收敛文件
 */

// 使用yymap时,会全局注册setInfo和shareCallback函数， 现删除yymap，防止端调用该函数出现异常报错
window.setInfo = function (infoData) {
    // infoData 参数，包括cuid sv c loc_x loc_y mb net os ov
};
window.shareCallback = function () {};
